/**
 * @class {T.ProfilePic}
 * @extends {mkE.Base}
 * @param {Object} par
 */
T.ProfilePic = Class(
	/**
	 * @lends {T.ProfilePic#}
	 */
	{
		picTmpId: null,
		uploading: false,

		/**
		 * @param {Object} par
		 * @constructs
		 */
		__construct: function(par){
			this.type = par.type;
			this.id = par.id;
			this.image = par.image;
			this.defaultImage = par.defaultImage;
			this.onChange = par.onChange || D.doNothing;
			this.canChange = par.canChange;
			this.showError = par.errorHandler || D.doNothing;

			this.node = mkE({
				tag: 'div',
				className: 'ProfilePicUpload' + (this.image ? ' has-image' : ''),
				els: [
					this._image = mkE({
						tag: 'div',
						className: 'upload-image',
						style: {
							backgroundImage: 'url(' + (this.image || this.defaultImage) + ')'
						}
					})
				]
			});

			this._uploadButton = mkE({
				tag: 'div',
				className: 'upload-button',
				text: this.image ? D.Lang.get('upload.change_image') : D.Lang.get('upload.upload')
			});

			if( this.canChange ){
				this._uploadButton.append(this.node);
			}

			this._initUploader();
		},

		_initUploader: function(){
			let p = new D.UploaderPar;
			p.accept = 'image/x-png,image/gif,image/jpeg';
			p.log = false;
			p.onSelect = this._onSelect;
			p.onGetUploadData = this._onGetUploadData;
			p.onUploadCompleteData = this._onUploadData;
			p.limit = 1;
			/** @type {D.NativeUploader} */
			this._uploader = new Uploader(p);
			this._uploader.append(this._uploadButton);
		},

		_onSelect: function(par){
			let ext = last(par.name.split('.'));
			ext = ext.toLowerCase();
			if( !in_array(ext, ['jpg', 'jpeg', 'png', 'gif']) ){
				this.showError(D.Lang.get('upload.errors.extension'));
				return;
			}
			this.uploading = true;
			addClassName(this._uploadButton, 'uploading');
			this.showError(null);
		},

		_onGetUploadData: function(){
			return {
				url: D.UPL + 'api.php',
				data: {
					type: this.type,
					id: this.id
				}
			};
		},

		_onUploadData: function(data){
			removeClassName(this._uploadButton, 'uploading');
			this.uploading = false;
			this._uploader.append(this._uploadButton);
			data = D.JSON.decode(data.data);
			if( !data ){
				this.showError(D.Lang.get('upload.errors.general'));
				return;
			}
			if( data.error ){
				let errorText = D.Lang.get('upload.errors.general');
				if( data.errorNr === 204 ){
					errorText = D.Lang.get('upload.errors.small');
				}
				this.showError(errorText);
				return;
			}
			addClassName(this.node, 'has-image');
			this._image.style.backgroundImage = 'url(' + data.pic.image.medium + ')';
			setNodeText(this._uploadButton, D.Lang.get('upload.change_image'));
			this._uploader.append(this._uploadButton);
			this.onChange(true);
		}
	},
	mkE.Base
);
